import { InputType } from 'config'

const ppOptions: Record<string, any> = {
  'Guaranteed Interest': 'Penalty in Months (Guaranteed Interest)',
  'Linear Step': 'Yearly Step Down (Linear Step)',
  Lockout: 'Strict Penalty in Months / Percentage / Specific Amount (Lockout)',
  'Non Linear Step': 'Yearly Step-Down (Non-Linear)',
}

const calculationOptions: Record<string, any> = {
  'Dollar Amount': 'Specific dollar amount',
  Months: 'A number of months interest',
  Prepaid: 'Percentage of the amount prepaid',
}

export const prepaymentKeys = [
  'prepaymentPremium',
  'prepaymentTerm0',
  'prepaymentTerm1',
  'prepaymentTerm2',
  'prepaymentTerm3',
  'prepaymentLockoutCalculation',
  'prepaymentLockoutAmount',
  'prepaymentLockoutMonths',
  'prepaymentLockoutPrepaid',
  'prepaymentSteps',
  'isPrepaymentMinimumPayment',
]

export const lockoutKeys = [
  'prepaymentLockoutCalculation',
  'prepaymentLockoutAmount',
  'prepaymentLockoutMonths',
  'prepaymentLockoutPrepaid',
]

export const defaultInputs = (): Record<string, InputType> => {
  let rtl: Record<string, InputType> = {
    closingDocumentDate: {
      inputType: 'text',
      type: 'date',
      title: 'Closing / Document Date',
      required: true,
    },
    custom1: {
      inputType: 'custom',
      title: 'custom1',
    },
    preparerName: {
      inputType: 'text',
      title: 'Preparer Name',
    },
    preparerEmail: {
      inputType: 'text',
      type: 'email',
      title: 'Preparer Email',
    },
    preparerAddress: {
      inputType: 'map',
      title: 'Preparer Address',
    },
    interestType: {
      title: 'Interest Type',
      inputType: 'select',
      hasDefaultOption: true,
      options: ['Dutch', 'Non Dutch'],
      required: true,
      history: false,
    },
    titleDate: {
      inputType: 'text',
      type: 'date',
      title: 'Title date',
      required: true,
    },
    titleAccountNumber: {
      inputType: 'text',
      type: 'text',
      title: 'Title Account Number',
      value: '',
      required: true,
    },
    lienPosition: {
      inputType: 'select',
      title: 'Lien Position',
      options: ['First', 'Second', 'Third'],
      hasDefaultOption: true,
      required: true,
      disabled: true,
    },
    apnNumber: {
      inputType: 'text',
      title: 'Parcel No',
      required: true,
      disabled: true,
    },
    escrowType: {
      title: 'Escrow Type',
      inputType: 'select',
      hasDefaultOption: true,
      options: ['Not Waived', 'Waive All', 'Waive Taxes', 'Waive Insurance', 'Waive Taxes and Insurance'],
      required: true,
    },
    isPrepaymentPremium: {
      inputType: 'checkbox',
      title: 'Is there a prepayment premium?',
      span: 'full',
    },
    prepaymentPremium: {
      inputType: 'select',
      title: 'Prepayment Premium Options',
      options: ppOptions,
      hasDefaultOption: true,
      required: true,
    },
    prepaymentTerm0: {
      inputType: 'text',
      type: 'thousandSepNoDecimal',
      title: 'Months of Guaranteed Interest',
    },
    prepaymentTerm1: {
      inputType: 'text',
      type: 'thousandSepNoDecimal',
      title: 'Prepay Step Years',
    },
    prepaymentTerm2: {
      inputType: 'text',
      type: 'thousandSepNoDecimal',
      title: 'Lockout Period (in months)',
    },
    prepaymentTerm3: {
      inputType: 'text',
      type: 'thousandSepNoDecimal',
      title: 'Number of Years',
    },
    prepaymentLockoutCalculation: {
      inputType: 'select',
      title: 'Premium is Calculated From',
      options: calculationOptions,
      hasDefaultOption: true,
    },
    prepaymentLockoutAmount: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Premium dollar amount',
      prefix: '$',
    },
    prepaymentLockoutMonths: {
      inputType: 'text',
      type: 'thousandSepNoDecimal',
      title: 'Months',
    },
    prepaymentLockoutPrepaid: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Percentage of Amount Prepaid (%)',
      prefix: '%',
    },
    prepaymentSteps: {
      inputType: 'autocomplete',
      type: 'number',
      title: 'Enter premium percentage during each year',
      checkExisting: false,
    },
    isPrepaymentMinimumPayment: {
      inputType: 'checkbox',
      title: 'Can borrower pay 20% in a year without triggering prepayment premium?',
    },
    custom3: {
      inputType: 'custom',
      title: 'custom',
      span: 'full',
    },
    personalGuaranty: {
      inputType: 'select',
      title: 'Personal Guaranty',
      options: ['Full Recourse', 'Non Recourse', 'Non Recourse with Bad Boy carveouts'],
      hasDefaultOption: true,
      required: true,
    },
    defaultRate: {
      inputType: 'text',
      type: 'number',
      prefix: '%',
      title: 'Default Rate',
      required: true,
    },
    enableExtension: {
      inputType: 'toggle',
      title: 'Enable Extension',
      value: false,
    },
    custom2: {
      inputType: 'custom',
      title: 'custom2',
    },
    numberOfExtensions: {
      inputType: 'text',
      type: 'number',
      title: 'Number of Allowable Extensions',
      required: true,
    },
    extensionFeePerc: {
      inputType: 'text',
      type: 'text',
      title: 'Extension Fee Percent',
      value: '',
      prefix: '%',
      required: true,
    },
    IncrementOfExtensions: {
      inputType: 'text',
      type: 'number',
      title: 'Increment of Extensions',
      required: true,
    },
    exceptions: {
      inputType: 'textarea',
      title: 'Exceptions to be removed',
      span: 'full',
      rows: 10,
    },
  }

  return rtl
}
